export default __webpack_public_path__ + "static/media/failed-btn.bf5fe84a.svg";